import React from 'react';
import {
  iconName,
  pluginName,
  qualify,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins, withSystem} from '@packages/systems/wfdl';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {maybeAddOpen} from './utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren, getInPojo, getTag} from '@packages/utilities/data-utils';

const NavbarButton = Atom.createRender(
  ({attributes, classes, generateAttributes, context, renderChild, data}) => {
    const Tag = getTag(getInPojo(data, ['tag'])) as React.ElementType;
    const navbarButtonClasses = classes
      .push('w-nav-button')
      .update(maybeAddOpen(context)('w--open'));
    return (
      <Tag {...generateAttributes(attributes, navbarButtonClasses)}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  constraints: {
    ancestors: [
      {
        is: 'NavbarWrapper',
        rule: 'ExactlyOne',
      },
    ],
  },
  displayName: 'Menu Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  render: NavbarButton,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
